import React, { useState } from 'react';
import { Modal } from '../common/Modal';
import { Sparkles, Check, User, Building2 } from 'lucide-react';

export function AddLeadModal({ isOpen, onClose, onAddLead, showToast }) {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    channel: 'line',
    propertyType: 'Luxury Villa',
    space: '250 sqm',
    budget: '฿120,000 / mo',
    businessType: 'Real Estate'
  });

  const [isCustomSpace, setIsCustomSpace] = useState(false);
  const [isCustomBudget, setIsCustomBudget] = useState(false);

  const handleQuickDemoFill = () => {
    setFormData({
      name: 'Khun Thanapol V.',
      company: 'Siam Future Tech Co., Ltd.',
      email: 'thanapol@siamfuturetech.co.th',
      phone: '081-889-1122',
      channel: 'line',
      propertyType: 'Luxury Villa',
      space: '250 sqm',
      budget: '฿120,000 / mo',
      businessType: 'Real Estate'
    });
    setIsCustomSpace(false);
    setIsCustomBudget(false);
    if (showToast) showToast('Auto-filled demo lead details', 'info');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.company) return;

    onAddLead({
      ...formData,
      status: 'qualified',
      score: 85,
      intent: 'High',
      urgency: 'Medium',
      assignedTo: 'TBS Sales Team'
    });

    if (showToast) showToast(`Lead added: ${formData.company}`, 'success');
    onClose();
    setFormData({
      name: '',
      company: '',
      email: '',
      phone: '',
      channel: 'line',
      propertyType: 'Luxury Villa',
      space: '250 sqm',
      budget: '฿120,000 / mo',
      businessType: 'Real Estate'
    });
  };

  const propertyOptions = [
    { label: 'Luxury Villa', val: 'Luxury Villa', icon: '🏡' },
    { label: 'Marina Berth', val: 'Marina Berth', icon: '⛵' },
    { label: 'Commercial Office', val: 'Commercial Office', icon: '🏢' },
    { label: 'Retail & F&B', val: 'Retail & F&B', icon: '🛍️' }
  ];

  const spaceOptions = ['100 sqm', '250 sqm', '500 sqm', '1,000 sqm', 'Berth 40ft+'];
  const budgetOptions = ['฿50,000 / mo', '฿120,000 / mo', '฿250,000 / mo', '฿500,000+ / mo'];

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add New Lead Enquiry" maxWidth="560px">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
        {/* Minimal Banner Helper */}
        <div style={{ padding: '10px 14px', backgroundColor: '#EBF8FC', border: '1px solid #A6E4FB', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: '12px', color: '#1e92c4', fontWeight: 600 }}>Lead Requirement Enquiry Form</span>
          <button
            type="button"
            onClick={handleQuickDemoFill}
            style={{
              background: 'none',
              border: 'none',
              color: '#2cabe1',
              fontSize: '12px',
              fontWeight: 700,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            <Sparkles size={13} color="#fdbb16" />
            <span>Auto-fill Demo</span>
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
          {/* Section 1: Contact Information */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ fontSize: '12px', fontWeight: 700, color: '#09090B', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <User size={13} color="#2cabe1" />
              <span>Contact Information</span>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div>
                <label style={{ fontSize: '12px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '5px' }}>
                  Contact Name <span style={{ color: '#DC2626' }}>*</span>
                </label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="e.g. Khun Somchai"
                  style={{ width: '100%', height: '38px', borderRadius: '6px' }}
                />
              </div>
              <div>
                <label style={{ fontSize: '12px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '5px' }}>
                  Company Name <span style={{ color: '#DC2626' }}>*</span>
                </label>
                <input
                  type="text"
                  required
                  value={formData.company}
                  onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  placeholder="e.g. Siam Logistics Co., Ltd."
                  style={{ width: '100%', height: '38px', borderRadius: '6px' }}
                />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div>
                <label style={{ fontSize: '12px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '5px' }}>Phone Number</label>
                <input
                  type="text"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  placeholder="081-234-5678"
                  style={{ width: '100%', height: '38px', borderRadius: '6px' }}
                />
              </div>
              <div>
                <label style={{ fontSize: '12px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '5px' }}>Acquisition Channel</label>
                <select
                  value={formData.channel}
                  onChange={(e) => setFormData({ ...formData, channel: e.target.value })}
                  style={{ width: '100%', height: '38px', borderRadius: '6px', cursor: 'pointer' }}
                >
                  <option value="line">LINE Official Account</option>
                  <option value="facebook">Facebook Lead Ads</option>
                  <option value="google">Google Search Ads</option>
                  <option value="tiktok">TikTok Ads</option>
                  <option value="website">Website Direct Inquiry</option>
                </select>
              </div>
            </div>
          </div>

          <div style={{ height: '1px', backgroundColor: '#E4E4E7' }} />

          {/* Section 2: Property Requirements */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div style={{ fontSize: '12px', fontWeight: 700, color: '#09090B', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Building2 size={13} color="#2cabe1" />
              <span>Property & Space Requirements</span>
            </div>

            {/* Property Type Grid Selector */}
            <div>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>
                Property / Facility Type
              </label>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
                {propertyOptions.map((p) => {
                  const isSelected = formData.propertyType === p.val;
                  return (
                    <button
                      key={p.val}
                      type="button"
                      onClick={() => setFormData({ ...formData, propertyType: p.val })}
                      style={{
                        padding: '8px 6px',
                        borderRadius: '8px',
                        border: isSelected ? '2px solid #2cabe1' : '1px solid #E4E4E7',
                        backgroundColor: isSelected ? '#EBF8FC' : '#FFFFFF',
                        color: isSelected ? '#1e92c4' : '#374151',
                        fontSize: '12px',
                        fontWeight: isSelected ? 700 : 500,
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '4px',
                        transition: 'all 0.15s ease'
                      }}
                    >
                      <span style={{ fontSize: '16px' }}>{p.icon}</span>
                      <span style={{ textAlign: 'center', fontSize: '11px' }}>{p.label}</span>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Space Required */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                <label style={{ fontSize: '12px', fontWeight: 600, color: '#374151' }}>Space / Spec Required</label>
                <button
                  type="button"
                  onClick={() => setIsCustomSpace(!isCustomSpace)}
                  style={{ fontSize: '11px', color: '#2cabe1', fontWeight: 600, background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  {isCustomSpace ? '• Select Presets' : '• Type Custom Size'}
                </button>
              </div>

              {!isCustomSpace ? (
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                  {spaceOptions.map((sp) => {
                    const isSelected = formData.space === sp;
                    return (
                      <button
                        key={sp}
                        type="button"
                        onClick={() => setFormData({ ...formData, space: sp })}
                        style={{
                          padding: '6px 12px',
                          borderRadius: '6px',
                          border: isSelected ? '2px solid #2cabe1' : '1px solid #E4E4E7',
                          backgroundColor: isSelected ? '#2cabe1' : '#FAFAFC',
                          color: isSelected ? '#FFFFFF' : '#374151',
                          fontSize: '12px',
                          fontWeight: isSelected ? 700 : 500,
                          cursor: 'pointer',
                          transition: 'all 0.15s ease'
                        }}
                      >
                        {sp}
                      </button>
                    );
                  })}
                </div>
              ) : (
                <input
                  type="text"
                  value={formData.space}
                  onChange={(e) => setFormData({ ...formData, space: e.target.value })}
                  placeholder="e.g. 250 sqm..."
                  style={{ width: '100%', height: '38px', borderRadius: '6px' }}
                />
              )}
            </div>

            {/* Monthly Budget */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                <label style={{ fontSize: '12px', fontWeight: 600, color: '#374151' }}>Monthly Budget</label>
                <button
                  type="button"
                  onClick={() => setIsCustomBudget(!isCustomBudget)}
                  style={{ fontSize: '11px', color: '#83c341', fontWeight: 600, background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  {isCustomBudget ? '• Select Presets' : '• Type Custom Budget'}
                </button>
              </div>

              {!isCustomBudget ? (
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                  {budgetOptions.map((bg) => {
                    const isSelected = formData.budget === bg;
                    return (
                      <button
                        key={bg}
                        type="button"
                        onClick={() => setFormData({ ...formData, budget: bg })}
                        style={{
                          padding: '6px 12px',
                          borderRadius: '6px',
                          border: isSelected ? '2px solid #83c341' : '1px solid #E4E4E7',
                          backgroundColor: isSelected ? '#83c341' : '#FAFAFC',
                          color: isSelected ? '#FFFFFF' : '#374151',
                          fontSize: '12px',
                          fontWeight: isSelected ? 700 : 500,
                          cursor: 'pointer',
                          transition: 'all 0.15s ease'
                        }}
                      >
                        {bg}
                      </button>
                    );
                  })}
                </div>
              ) : (
                <input
                  type="text"
                  value={formData.budget}
                  onChange={(e) => setFormData({ ...formData, budget: e.target.value })}
                  placeholder="e.g. ฿120,000 / mo..."
                  style={{ width: '100%', height: '38px', borderRadius: '6px' }}
                />
              )}
            </div>
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '6px', paddingTop: '16px', borderTop: '1px solid #E4E4E7' }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                height: '38px',
                padding: '0 18px',
                borderRadius: '6px',
                border: '1px solid #D4D4D8',
                backgroundColor: '#FFFFFF',
                color: '#374151',
                fontSize: '13px',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                height: '38px',
                padding: '0 22px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#2cabe1',
                color: '#FFFFFF',
                fontSize: '13.5px',
                fontWeight: 700,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                boxShadow: '0 2px 4px rgba(44, 171, 225, 0.3)'
              }}
            >
              <Check size={16} />
              <span>Save Lead</span>
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}
